/**
 * Copyright (c) 2024 CalAmp Corp. All Rights Reserved
 */

import {ColDef} from 'ag-grid-community';

export const PREFERENCE_NAME = 'savedColumns';
export const MAX_LENGTH = 10;
export const HIDE_DURATION = 3000;
export const COLUMN_NAME_MAX_LENGTH = 13;

export interface ColumnWithOrderKey extends ColDef {
  order: number;
}

export interface SavedColumnItem {
  columns: string;
  viewName: string;
}

export type SavedColumnType = {
  pageName: string;
  createdAt: Date;
  views: SavedColumnItem[];
  selectedViewName: string;
  isNotAllowToCreate: boolean;
};

export enum ArgumentTypes {
  IS_NAME_EXIST = 'isNameExist',
  iS_MORETHAN_MAX = 'isMorethanMax',
  iS_SUCCESS = 'isSuccess'
}

export type CallbackArgumentsType = {
  [ArgumentTypes.IS_NAME_EXIST]?: boolean;
  [ArgumentTypes.iS_MORETHAN_MAX]?: boolean;
  [ArgumentTypes.iS_SUCCESS]?: boolean;
};

export enum ColumnFormatKeys {
  COL_ID = 'col_id',
  ORDER = 'order',
  SORT = 'sort',
  WIDTH = 'width'
};

export interface ColumnFormatType {
  [ColumnFormatKeys.COL_ID]?: string;
  [ColumnFormatKeys.ORDER]?: number;
  [ColumnFormatKeys.SORT]?: string | null;
  [ColumnFormatKeys.WIDTH]?: number;
};

export type GetSavedColAndCurrentColReturnType = {
  selectedSavedViewColumn: string;
  currentColumn: string;
  currentColumnWithWidth?: string;
};
